import { styled } from '$utils/theme'
import { Block } from '$views/components/Layout/Block'
import { Text } from '$views/components'

interface Props {
  backgroundColor: string
}

export const StyledIconWithTextContainer = styled.div`
  display: flex;
  &:hover {
    cursor: pointer;
  }
  width: 70px;
  justify-content: center;
  align-items: flex-start;
`

export const IconBackground = styled(Block)<Props>`
  width: 45px;
  height: 45px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${p => (p.backgroundColor ? p.theme.colors[p.backgroundColor] : p.theme.colors.lightGrey)};
  margin: auto;
`
export const StyledIconText = styled(Text)`
  position: relative;
  top: 1px;
`



// WEBPACK FOOTER //
// ./src/views/components/IconWithText/IconWithText.style.ts